export default {
	projectImagesPath: '/projects-images/'
};
